import { render, staticRenderFns } from "./editMatchModalCustom.vue?vue&type=template&id=1fc22db2&scoped=true"
import script from "./editMatchModalCustom.vue?vue&type=script&lang=js"
export * from "./editMatchModalCustom.vue?vue&type=script&lang=js"
import style0 from "./editMatchModalCustom.vue?vue&type=style&index=0&id=1fc22db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc22db2",
  null
  
)

export default component.exports